import React from 'react';
import AutoCompleteFilter from './../AutoComplete/AutoCompleteFilter';

export const ListCustomFilterListOptions = (col) => {
  return {
    render: (v) => {
      console.log(col.options.listSeparator);
      let value = v?.toString() || '';
      let newValue = '';

      if (value != '') {
        const data = value.split(col.options.listSeparator);
        const items = [];
        for (const item of data) {
          if (!items.includes(item) && item.trim() !== '') {
            items.push(item);
          }
        }
        items.map((item) => {
          newValue = newValue + item + ', ';
        });

        newValue = newValue + ',';
        newValue = newValue.replace(', ,', '');
      }

      return v.toString() !== '' ? `${col.label}: ${newValue}` : [];
    },
    update: (filterList, filterPos, index) => {
      if (filterPos === 0) {
        filterList[index].splice(filterPos, 1, '');
      } else if (filterPos === 1) {
        filterList[index].splice(filterPos, 1);
      } else if (filterPos === -1) {
        filterList[index] = [];
      }
      return filterList;
    },
  };
};

export const ListFilterOptions = (listSeparator) => {
  return {
    logic: (value, filters) => {
      if (filters.length > 0 && filters[0] !== '') {
        return !filters.includes(value);
      }
      return false;
    },
    display: (filterList, onChange, index, column, filterData) => {
      return (
        <AutoCompleteFilter
          freeSolo={true}
          name={column.name}
          label={column.label}
          value={filterList[index][0] || ''}
          onChange={(event) => {
            filterList[index][0] = event.currentTarget.value;
            onChange(filterList[index], index, column);
          }}
          options={filterData[index]}
          filterType={'list'}
          listSeparator={listSeparator}
        />
      );
    },
  };
};

export default {
  ListFilterOptions,
  ListCustomFilterListOptions,
};
